<template>
	<mail-action-test-editor v-if="visible"
		:style="style" :class="clazz" :ro="ro" :error-path="property"
		:value="value" @update-value="updateValue" />
</template>

<script setup lang="ts">
import {computed, ref, onMounted} from "vue";
import useEditor, {type EditorProps, editorProps} from "@fd/editors/Editor";

import type {MailActionTestPart} from "@t/fd/editor/MailActionTest";
import type {MailActionTest} from "@t/mail/MailAction";
import MailActionTestEditor from "@fd/editors/mail/MailActionTestEditor.vue";

import {injectEnv} from "@fd/Environment";

const uprops = defineProps({
	...editorProps
});

const props = uprops as EditorProps;
const mailActionTest = computed<MailActionTestPart>(() => props.part as MailActionTestPart);
const {visible, value, clazz, errorClass, errors, style, ro, vm} = useEditor(props);
const env = injectEnv();

function updateValue(test: MailActionTest): void {
	//console.log("update:"+JSON.stringify(test));
	value.value = test;
}

const property = computed(() => {
	return props.part.property;
});

</script>

<style>
.fd-mailtest-array {
	position: relative;
	display: flex;
	flex-direction: column;
	row-gap: 6px;
	width: 100%;
}

	
.fd-mailtest-item {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: baseline;
	column-gap: 4px;
	padding: 4px;
	border-radius: var(--button-radius);
	border: 1px solid var(--border-color);
	position: relative;
	margin-right: 0px;
	transition: border-color 500ms;
	flex: 1;
}
.fd-array-item[data-index="0"] > .fd-array-item-content > .fd-mailtest-item {
	opacity: 0.1;
}

.fd-mailtest-item:hover {
	color: var(--form-fg);
}

.invalid-rule {
    color: var(--error-fg);
    background-color: var(--error-bg);
}

.valid-rule {
	color: var(--fg);
    background-color: var(--bg);
}

</style>
